import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { UserRole } from '../types';
import { 
  HomeIcon, 
  UserGroupIcon, 
  AcademicCapIcon, 
  BanknotesIcon, 
  CogIcon, 
  ArrowRightOnRectangleIcon,
  ShoppingBagIcon,
  BookOpenIcon,
  UsersIcon ,TruckIcon// 🟢 جديد
} from '@heroicons/react/24/outline';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const commonLinks = [
    { to: '/', text: 'الرئيسية', icon: HomeIcon },
  ];

  const secretaryLinks = [
    { to: '/students', text: 'الطلاب', icon: UserGroupIcon },
    { to: '/classes', text: 'الشعب', icon: AcademicCapIcon },
  ];

  const accountantLinks = [
    { to: '/students', text: 'الطلاب', icon: UserGroupIcon },
            { to: '/TeachersPage', text: 'المدرّسين ', icon: UsersIcon },

    { to: '/accounting', text: 'المحاسبة', icon: BanknotesIcon },
    { to: '/TransportPage', text: 'إدارة النقل', icon: TruckIcon },

    { to: '/users', text: 'إدارة عامة', icon: CogIcon },


  ];

  const ownerLinks = [
        ...secretaryLinks,
    ...accountantLinks,

            { to: '/books', text: 'إدارة الكتب', icon: BookOpenIcon }, // 🟢 جديد

    { to: '/clothes', text: 'إدارة الملابس', icon: ShoppingBagIcon }, 

 

  ];

  let links = commonLinks;
  if (user?.role === UserRole.OWNER) {
    // Filter out duplicates that might come from both secretary and accountant links
    links = [...commonLinks, ...ownerLinks.filter((link, index, self) => self.findIndex(l => l.to === link.to) === index)];
  } else if (user?.role === UserRole.SECRETARY) {
    links = [...commonLinks, ...secretaryLinks];
  } else if (user?.role === UserRole.ACCOUNTANT) {
    links = [...commonLinks, ...accountantLinks];
  }

  // --- (تعديل) إضافة زر تسجيل الخروج كآخر عنصر في القائمة لجميع الأدوار ---
  links.push({ to: 'logout', text: 'تسجيل الخروج', icon: ArrowRightOnRectangleIcon });

  const linkClass = "flex items-center px-4 py-3 text-md text-slate-900 hover:bg-slate-200 rounded-md transition-colors duration-200";
  const activeLinkClass = "flex items-center px-4 py-3 text-md bg-blue-500 text-white rounded-md font-bold shadow-md";
  
  // --- (تعديل) فئة زر تسجيل الخروج لتطابق الروابط ---
  const logoutClass = "w-full flex items-center px-4 py-3 text-md text-red-700 hover:bg-red-100 rounded-md transition-colors duration-200";


  return (
    <div className="w-64 bg-white shadow-lg h-full flex flex-col p-3">
      <div className="text-3xl font-bold text-center text-blue-700 py-4 mb-4 border-b">
         الغدّ المشرق  </div>
      
      {/* --- (تعديل) قائمة التنقل تحتوي الآن على زر تسجيل الخروج --- */}
      <nav className="flex-1 space-y-2">
        {links.map(({ to, text, icon: Icon }) => {
          
          // --- (جديد) التحقق إذا كان الرابط هو زر تسجيل الخروج ---
          if (to === 'logout') {
            return (
              <button 
                key="logout"
                onClick={handleLogout} 
                className={logoutClass}
              >
                <Icon className="h-6 w-6 ml-3" />
                {text}
              </button>
            );
          }
          
          // --- عرض الروابط العادية ---
          return (
            <NavLink key={to} to={to} className={({ isActive }) => isActive ? activeLinkClass : linkClass} end>
              <Icon className="h-6 w-6 ml-3 " />
              {text}
            </NavLink>
          );
        })}
      </nav>
      
      
         <div className="p-6 flex flex-col justify-center">
            <img 
              src="/logo.jpg" // This path works because the image is in the 'public' folder
              alt="شعار المدرسة" 
              className="w-30 h-30 rounded-full object-cover overflow-hidden" 
              // This function will hide the image if it fails to load
              onError={(e) => { 
                e.target.style.display = 'none'; 
                console.error('Logo not found at /logo.jpg. Make sure it is in the public folder.'); 
              }}
            />
          </div>

      
    </div>
  );
};

export default Sidebar;